import { render } from "./container-contacts.vue?vue&type=template&id=43c96a3c"
import script from "./container-contacts.vue?vue&type=script&lang=js"
export * from "./container-contacts.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__